import { useEffect, useState, RefObject } from "react";

/**
 * Custom hook để kiểm tra một phần tử có đang nằm trong viewport hay không
 * @param ref - ref của element cần theo dõi
 * @param options - options cho IntersectionObserver (optional)
 * @returns true nếu element đang trong viewport
 */
export function useIsInViewport(
  ref: RefObject<Element>,
  options: IntersectionObserverInit = { threshold: 0 }
): boolean {
  const [isInViewport, setIsInViewport] = useState<boolean>(false);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new IntersectionObserver(([entry]) => {
      setIsInViewport(entry.isIntersecting);
    }, options);

    observer.observe(ref.current);

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref, options]);

  return isInViewport;
}
